import React from 'react';
import TrackingJS from '@vp/react-tracking';
import { getCurrentLocale } from './utils/locale';
import { isDevelopmentMode } from './utils/utils';

const Analytics = () => (
    <TrackingJS
        version='6'
        tenant='vistaprint'
        environment={isDevelopmentMode() ? 'dev' : 'prod'}
        culture={getCurrentLocale()}
        suppressReloadOnConsentSubmit={true}
    />);

export default Analytics;
